import React from 'react'
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import MedicoContent from '../page_content/MedicoContent'

const Medico = () => {
    return (
        <div>
            <Header />
            <MedicoContent/>
            <Footer />
        </div>
    )
}

export default Medico